import { globalApiParams } from './globals';
import { deleteRequest, get, post, put } from '../../helpers/axiosWrapper';

export const getScheduledReportRequests = async (
  url: string | undefined,
  context: any,
  page: number
): Promise<Common.IResult<Api.IScheduledReportRequest>> => {
  return await get(
    `${url}/scheduledtasks/scheduledreportrequests?&page=${page}&pageSize=${globalApiParams.pageSize}`,
    {},
    context
  );
};

export const createScheduledReportRequests = async (
  url: string | undefined,
  context: any,
  reportData: any
): Promise<any> => {
  return await post(url + `/scheduledtasks/scheduledreportrequests`, { data: reportData }, context);
};

export const updateScheduledReportRequests = async (
  url: string | undefined,
  context: any,
  reportData: any
): Promise<any> => {
  return await put(url + `/scheduledtasks/scheduledreportrequests`, reportData, context);
};

export const deleteScheduledReportRequest = async (
  url: string | undefined,
  context: any,
  scheduledReportId: any
): Promise<any> => {
  return await deleteRequest(url + `/scheduledtasks/scheduledreportrequests?&id=${scheduledReportId}`,  {}, context);
};
